import { useAccount, useBalance } from "wagmi"
import { Address, formatUnits } from "viem"
import { CHAIN_ID } from "./constants"

/**
 * This hook returns the number of coins that the user has
 * @param tokenAddress the ERC20 contract of the coin
 * @returns the number of coins the user currently has or undefined if the balance fails
 */
export function useInitialCoins(tokenAddress: Address): string | undefined {
  const { address } = useAccount()
  const { data } = useBalance({
    address,
    token: tokenAddress,
    chainId: CHAIN_ID,
  })

  if (data) {
    return formatUnits(data.value, data.decimals)
  }

  return undefined
}
